import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    if (this.authService.isLoggedIn()) {
      // Verificar si tiene suscripción activa
      if (!this.authService.hasActiveSubscription()) {
        console.warn('Suscripción inactiva o expirada');
        // Podrías redirigir a una página de renovación o mostrar un mensaje
        // this.router.navigate(['/subscription-expired']);
      }
      return true;
    }

    // No está autenticado, redirigir al login
    console.log('Usuario no autenticado, redirigiendo a login');
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: state.url }
    });
    return false;
  }
}

